import moment from "moment"
import axios from "axios"
import router from "../../router"
export default {
  namespaced: true,
  state: {
    loader: false,
    snackbar: {
      value: false,
      text: "",
      timeout: 2000,
      color: "",
    },
  },
  mutations: {
    SET_ALERT(state, payload) {
      state.snackbar.value = payload.value
      state.snackbar.text = payload.text
      state.snackbar.timeout = payload.timeout || 2000
      switch (payload.type) {
        case "error":
          state.snackbar.color = "red"
          break
        case "success":
          state.snackbar.color = "green"
          break
        default:
          state.snackbar.color = "teal"
          break
      }
    },
  },
  actions: {
    alert({ commit, state }, payload) {
      console.log(payload)
      commit("SET_ALERT", payload)
    },
  },
  getters: {
    snackbar(state) {
      return state.snackbar
    },
    loader(state) {
      return state.loader
    },
  },
}
